module.exports = __webpack_public_path__ + "static/tutorial-slide-2-cb3b83a82072407819d0e95a154538c4.png";